import { Component, OnInit } from '@angular/core';
import { Labels } from '@serasa/shared/labels';
import { Utils } from '@serasa/shared/utils/utils';
import { SedsBasicButtonModule, SedsModalAbstractComponent, SedsModalModule } from "@serasa/shared/seds";

@Component({
    selector: 'pl-renovate-modal-expired',
    templateUrl: 'renovate-modal-expired.component.html',
    styleUrls: ["../../../styles/theme/modal.scss"],
    imports: [SedsModalModule, SedsBasicButtonModule]
})
export class RenovateModalExpiredComponent extends SedsModalAbstractComponent implements OnInit {

  public labels = new Labels();

  public Utils = Utils;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  public logout(): void {
    this.Utils.deleteCookie("accessToken");
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");
    this.close();
    Utils.redirectToLogin();
  }

}
